import React, { Component } from "react";
import axios from "axios";
import api from "../api";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { MenuItem } from "@material-ui/core";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: "100%"
  },
  appBar: {
    position: "relative"
  },
  title: {
    marginLeft: "2rem",
    flex: 1,
    color: "white"
  },
  paper: {
    padding: "2rem",
    textAlign: "center"
  },
  checkedIcon: {
    width: 16,
    height: 16
  },
  checkbox: {
    padding: 0,
    paddingRight: "4px",
    marginLeft: "4px",
    marginRight: "8px"
  },
  option: {
    fontWeight: 600,
    fontSize: "0.75rem"
  },
  typography: {
    fontSize: "0.75rem"
  },
  select: {
    marginTop: "0",
    marginRight: "12px",
    padding: "0"
  },
  menu: {
    fontSize: "0.7rem"
  }
});

class Approvals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      work_order_approvals: [{}],
      work_order_approval: { work_order: {} },
      snackbar: { open: false },
      loading: true,
      saving: false,
      approvers: []
    };
  }

  async componentDidMount() {
    var work_order_id = this.props.id;
    await this.getWorkOrderApproval(work_order_id);
    await this.getApprovers();
    this.setState({ loading: false });
  }

  async getWorkOrderApproval(id) {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.work_order_approval().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var work_order_approvals = res.data;
        this.setState({
          work_order_approvals: work_order_approvals,
          loading: false
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  async getApprovers() {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.work_order_approval().approvers(this.props.id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var approvers = res.data;
        this.setState({
          approvers: approvers
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  handleChange = e => {
    var work_order_approval = this.state.work_order_approval;
    work_order_approval[e.target.name] = e.target.value;
    this.setState({ work_order_approval: work_order_approval });
  };

  handleSubmit = () => {
    this.setState({ saving: true });
    var formData = new FormData();
    var url = api.work_order_approval().post();
    formData.set("work_order_approval[work_order_id]", this.props.id);
    formData.set(
      "work_order_approval[email]",
      this.state.work_order_approval.email
        ? this.state.work_order_approval.email
        : ""
    );
    formData.set("work_order_approval[approve_required]", 1);
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var snackbar = {
          open: true,
          success_message: "Aprobación cargada con éxito",
          severity: "success"
        };
        self.setState({ snackbar: snackbar });
        self.setState({ saving: false });
        var work_order_id = self.props.id;
        self.getWorkOrderApproval(work_order_id);
      })
      .catch(function(error) {
        //	      		var error_message = 'Ha ocurrido un error al cargar el movimiento. Por favor contacte con su administrador'
        var error_message = "";
        var errors = error.response.data;
        if (errors.errors) {
          if (errors.status_code !== 404) {
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = error_message.concat(error.message).concat(" ");
          }
        }

        var snackbar = {
          open: true,
          success_message: error_message,
          severity: "warning"
        };
        self.setState({ saving: false });
        self.setState({ snackbar: snackbar });
      });
  };

  handleReclaim = (e, id) => {
    var formData = new FormData();
    var url = api.work_order_approval().reclaim(id);
    formData.set("id", id);
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var snackbar = {
          open: true,
          success_message: "Reclamo cargado con éxito",
          severity: "success"
        };
        self.setState({ snackbar: snackbar });
      })
      .catch(function(error) {
        var error_message =
          "Ha ocurrido un error al realizar el reclamo. Por favor contacte con su administrador";
        var snackbar = {
          open: true,
          success_message: error_message,
          severity: "warning"
        };
        self.setState({ snackbar: snackbar });
      });
  };

  handleSnackbar = () => {
    var snackbar = this.state.snackbar;
    snackbar.open = !snackbar.open;
    this.setState({ snackbar: snackbar });
  };

  render() {
    var work_order_approvals = this.state.work_order_approvals;
    var work_order_approval = this.state.work_order_approval;
    const classes = this.props.classes;
    return (
      <React.Fragment>
        <Snackbar
          open={this.state.snackbar.open}
          autoHideDuration={10000}
          onClose={this.handleSnackbar}
        >
          <Alert
            onClose={this.handleSnackbar}
            severity={this.state.snackbar.severity}
          >
            {this.state.snackbar.success_message}
          </Alert>
        </Snackbar>
        {this.state.loading ? (
          ""
        ) : (
          <React.Fragment>
            <div className="row mt-2">
              <Table
                size="small"
                aria-label="a dense table"
                style={{ width: "auto" }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550" }}
                    >
                      Email
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550" }}
                    >
                      Estado
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550" }}
                    >
                      Motivo de rechazo
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550" }}
                    >
                      Fecha enviado
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550" }}
                    >
                      Fecha respuesta
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: "550" }}
                    >
                      &nbsp;
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {work_order_approvals.map((val, idx) => {
                    var approval_state = "Enviado";
                    var answer_date = "";
                    var can_reclaim = true;
                    if (val.approved) {
                      approval_state = "Aprobado";
                      answer_date = val.approve_date;
                      can_reclaim = false;
                    }
                    if (val.rejected) {
                      approval_state = "Rechazado";
                      answer_date = val.reject_date;
                      can_reclaim = false;
                    }
                    return (
                      <TableRow>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.7rem" }}
                        >
                          {val.email}
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.7rem" }}
                        >
                          {approval_state}
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.7rem" }}
                        >
                          {val.reject_reason ? val.reject_reason : ""}
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.7rem" }}
                        >
                          {val.created_at}
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.7rem" }}
                        >
                          {answer_date}
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontSize: "0.7rem" }}
                        >
                          {can_reclaim ? (
                            <Button
                              className="mt-1"
                              variant="contained"
                              color="primary"
                              size="small"
                              style={{ fontSize: "0.75rem" }}
                              onClick={e => {
                                this.handleReclaim(e, val.id);
                              }}
                            >
                              Reclamar
                            </Button>
                          ) : (
                            ""
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>

            <div className="row mt-2">
              <TextField
                id="email"
                value={work_order_approval.email}
                onChange={this.handleChange}
                name="email"
                select
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Email Aprobador</Typography>
                    </InputAdornment>
                  )
                }}
              >
                {this.state.approvers.length > 0 ? (
                  this.state.approvers.map((val, idx) => (
                    <MenuItem
                      key={idx}
                      value={val.contact.email}
                      className={classes.menu}
                      style={{ fontSize: "0.7rem" }}
                    >
                      {val.firstname} {val.lastname} ({val.contact.email})
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled value="">
                    Sin aprobadores
                  </MenuItem>
                )}
              </TextField>
              {/*
                            <FormControlLabel
								control={                            	
									<Checkbox
										id="approve"
										name="approve"
										disabled={true}
										className={classes.checkbox}
										onChange={this.handleChange}
										value={work_order_approval.approve}
										checked={work_order_approval.approve}
										color="primary"
										inputProps={{ 'aria-label': 'secondary checkbox' }}
									/>
								}
								label={<Typography variant="caption" >Aprobado?</Typography>}
								labelPlacement="start"
                            />
							*/}

              {/*(parseInt(work_order_approval.approve) === 1)
                            ?
                                <TextField
                                    id="approve_date"
                                    disabled={true}
                                    value={work_order_approval.approve_date}
                                    onChange={this.handleChange}
                                    type="date"
                                    name="approve_date"
                                    margin="normal"
                                    className="m-0 p-0 mr-2"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start" ><Typography variant="caption">Fecha aprobción</Typography></InputAdornment>,
                                    }}
                                />		
                            :
                                ''
								*/}
            </div>

            <div className="row mt-2">
              <Button
                disabled={this.state.saving === true ? true : false}
                className="mt-1"
                variant="contained"
                color="primary"
                size="small"
                style={{ fontSize: "0.75rem" }}
                onClick={e => {
                  this.handleSubmit(e);
                }}
              >
                {this.state.work_order_approval.id ? "Guardar" : "Cargar"}
              </Button>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default withStyles(useStyles)(Approvals);
